import React from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import BaseDropdown from "@/components/reusables/dropdowns/BaseDropdown";
import { Shopify } from "@/types/general";
import { LocationsMapperFormTyping, generateLocationLabel } from "./utils";

interface ShopifyLocationDropdownProps {
    control: Control<LocationsMapperFormTyping>;
    index: number;
    availableShopifyLocations?: Shopify.Location[];
    isLoading: boolean;
}

export default React.memo(function ShopifyLocationDropdown({
    control,
    index,
    availableShopifyLocations,
    isLoading,
}: ShopifyLocationDropdownProps) {
    const { t } = useTranslation("", { keyPrefix: "imports.modules.shopify.importModal.locationsMapper" });
    
    return (
        <Controller
            control={control}
            name={`mappings.${index}.shopify_location`}
            render={({ field, fieldState }) => (
                <BaseDropdown
                    {...field}
                    {...fieldState}
                    options={availableShopifyLocations}
                    getter={{
                        label: (opt) =>
                            generateLocationLabel(
                                opt.location.store_name,
                                opt.location.section_name
                            ),
                        key: (opt) => opt.shopify_id,
                        renderOption: (opt, icon) => (
                            <div className="flex items-center justify-between w-full">
                                <div className="grow">
                                    <div className="bold-highlight">{opt.location.store_name}</div>
                                    {opt.location.section_name && (
                                        <div className="text-sm text-gray-500">
                                            {opt.location.section_name}
                                        </div>
                                    )}
                                </div>
                                {icon}
                            </div>
                        ),
                    }}
                    placeholder={t("fields.shopify.placeholder")}
                    isLoading={isLoading}
                    autocomplete
                />
            )}
        />
    );
});
